import { Component, OnInit, Input, ChangeDetectionStrategy, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { PriceHelper } from "../helpers/PriceHelper";
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-detail-price',
  templateUrl: './detail-price.component.html',
  styleUrls: ['./detail-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailPriceComponent extends BaseComponent implements OnInit {

  buySelected: boolean = true;

  @Input() item;
  @Output() onBuySelected = new EventEmitter();

  @ViewChild('amazonPriceInfo', {static: false}) amazonPriceInfo;

  constructor() {
    super();
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.hasRentalPrices() && (!this.hasBuyPrices() || StorageHelper.getInstance().get(StorageHelper.keys.detailViewMediaType) == Global.RENTALMOVIES)) {
      this.buySelected = false;
    }
  }

  storeIsAmazon(): boolean {
    return Global.getStore() == Global.AMAZON;
  }

  shouldDisplayRentalPrice(): boolean {
    if(this.item.itemType == "movie") {
      return true;
    }
    false;
  }

  hasBuyPrices(): boolean {
    if(this.item.priceHd || this.item.priceSd) {
      return true;
    }
    return false;
  }

  hasRentalPrices(): boolean {
    if(this.item.rentalPriceHd || this.item.rentalPriceSd) {
      return true;
    }
    return false;
  }

  has4kPrice(): boolean {
    return PriceHelper.has4kPrice(this.item, this.buySelected);
  }

  hasHdPrice() {
    return PriceHelper.hasHdPrice(this.item, this.buySelected);
  }

  hasSdPrice() {
    return PriceHelper.hasSdPrice(this.item, this.buySelected);
  }

  hasPrice() {
    return PriceHelper.hasPrice(this.item, this.buySelected);
  }

  get4kPrice(){
    return PriceHelper.get4kPrice(this.item, this.buySelected);
  }

  getHdPrice(){
    return PriceHelper.getHdPrice(this.item, this.buySelected);
  }

  getSdPrice(){
    return PriceHelper.getSdPrice(this.item, this.buySelected);
  }

  getPrice(){
    if(this.buySelected){
      return this.getPriceToDisplay(this.item.price, this.item.currency);
    }
    else {
      return this.getPriceToDisplay(this.item.rentalPrice, this.item.currency);
    }
  }

  getSdPriceBefore() {
    if(this.buySelected){
      return PriceHelper.formatPrice(this.item.priceSdBefore, this.item.currency);
    }
    else {
      return PriceHelper.formatPrice(this.item.rentalPriceSdBefore, this.item.currency);
    }
  }

  getHdPriceBefore() {
    if(this.buySelected){
      return PriceHelper.formatPrice(this.item.priceHdBefore, this.item.currency);
    }
    else {
      return PriceHelper.formatPrice(this.item.rentalPriceHdBefore, this.item.currency);
    }
  }

  get4kPriceBefore() {
    if(this.buySelected) {
      return PriceHelper.formatPrice(this.item.price4kBefore, this.item.currency);
    }
    else {
      return PriceHelper.formatPrice(this.item.rentalPrice4kBefore, this.item.currency);
    }
  }

  getPriceBefore() {
    if(this.buySelected){
      return this.getPriceToDisplay(this.item.priceBefore, this.item.currency);
    }
    else {
      return this.getPriceToDisplay(this.item.rentalPriceBefore, this.item.currency);
    }
  }

  private getPriceToDisplay(price:number, currency: string): string {
    if(price != null && price == 0) {
      return this.getString("free");
    }

    return PriceHelper.formatPrice(price, currency);
  }

  getPriceSdIsBest() {
    if(this.buySelected){
      return this.item.priceSdIsBest;
    }
    else {
      return this.item.rentalPriceSdIsBest;
    }
  }

  getPriceSdIsLowest() {
    if (this.buySelected) {
      return this.item.priceSdIsLowest;
    }
    else {
      return this.item.rentalPriceSdIsLowest;
    }
  }

  getPriceSdDropIndicator() {
    if(this.buySelected){
      return this.item.priceSdDropIndicator;
    }
    else {
      return this.item.rentalPriceSdDropIndicator;
    }
  }

  getPriceHdIsBest() {
    if(this.buySelected){
      return this.item.priceHdIsBest;
    }
    else {
      return this.item.rentalPriceHdIsBest;
    }
  }

  getPriceHdIsLowest() {
    if (this.buySelected) {
      return this.item.priceHdIsLowest;
    }
    else {
      return this.item.rentalPriceHdIsLowest;
    }
  }

  getPrice4kIsBest() {
    if(this.buySelected) {
      return this.item.price4kIsBest;
    }
    else {
      return this.item.rentalPrice4kIsBest;
    }
  }

  getPrice4kIsLowest() {
    if (this.buySelected) {
      return this.item.price4kIsLowest;
    }
    else {
      return this.item.rentalPrice4kIsLowest;
    }
  }

  getPriceHdDropIndicator() {
    if(this.buySelected){
      return this.item.priceHdDropIndicator;
    }
    else {
      return this.item.rentalPriceHdDropIndicator;
    }
  }

  getPrice4kDropIndicator() {
    if(this.buySelected) {
      return this.item.price4kDropIndicator;
    }
    else {
      return this.item.rentalPrice4kDropIndicator;
    }

  }

  getPriceIsBest() {
    if(this.buySelected){
      return this.item.priceIsBest;
    }
    else {
      return this.item.rentalPriceIsBest;
    }
  }

  getPriceIsLowest() {
    if (this.buySelected) {
      return this.item.priceIslowest;
    }
    else {
      return this.item.rentalPriceIsLowest;
    }
  }

  getPriceDropIndicator() {
    if(this.buySelected){
      return this.item.priceDropIndicator;
    }
    else {
      return this.item.rentalPriceDropIndicator;
    }
  }

  buyClick() {
    this.buySelected = true;
    this.onBuySelected.emit(true);
    StorageHelper.getInstance().save(StorageHelper.keys.detailViewMediaType, Global.BUYMOVIES);
  }

  rentClick() {
    this.buySelected = false;
    this.onBuySelected.emit(false);
    StorageHelper.getInstance().save(StorageHelper.keys.detailViewMediaType, Global.RENTALMOVIES);
  }

  getTimeStamp() {
    const key = PriceHelper.getCompletePriceKey("Timestamp", "offerslist", this.item, false);
    return (this.item[key] || "") + " CET";
  }

  showAmazonPriceMoreInfo() {
    this.amazonPriceInfo.open();
  }

}
